import { Injectable } from '@angular/core';

import { BaseStorage } from '../../core/abstractions/base.storage';

@Injectable({
    providedIn: 'root'
})
export class SyncStorage extends BaseStorage {
    private lastSyncKey = 'lastSyncKey';
    private readonly lastFullSyncKey = 'lastFullSync';

    constructor() {
        super('security');
    }

    saveLastSync(lastSyncDate: Date): void {
        this.save(lastSyncDate, this.lastSyncKey);
    }

    getLastSync(): Date {
        return new Date(this.get(this.lastSyncKey));
    }

    eraseLastSync(): void {
        this.remove(this.lastSyncKey);
    }

    saveLastFullSync(lastFullSync: Date): void {
        this.save(lastFullSync, this.lastFullSyncKey);
    }

    getLastFullSync(): Date {
        return new Date(this.get(this.lastFullSyncKey));
    }

    eraseLastFullSync(): void {
        this.remove(this.lastFullSyncKey);
    }

    lastFullSyncExists(): boolean {
        return !!this.get(this.lastFullSyncKey);
    }
}
